module.exports = __webpack_public_path__ + "static/media/tv-retro.e0fb0eb0.svg";